import { Link, createFileRoute } from '@tanstack/react-router';
import {
  BrainIcon,
  ShieldAlertIcon,
  StethoscopeIcon,
  type LucideIcon,
} from 'lucide-react';

import LogoHorizontal from '@assets/logo-horizontal.png';

export const Route = createFileRoute('/under-review')({
  component: UnderReview,
});

function UnderReview() {
  return (
    <div className="bg-primary relative">
      <div className="gradient-background absolute h-full min-h-dvh w-full" />
      <main className="relative mx-auto flex min-h-dvh w-full flex-col items-center justify-center p-4">
        <ShieldAlertIcon
          className="text-secondary"
          size={100}
          strokeWidth={1}
        />

        <h1 className="text-secondary my-4 text-4xl font-semibold">
          Sua conta está em análise!
        </h1>

        <div className="my-4">
          <Info
            description="Ajude a construir a maior base de conteúdos médicos práticos do Brasil"
            icon={BrainIcon}
            title="Colabore"
          />

          <Info
            description="Atualize conteúdos e ajude médicos a tomarem decisões mais seguras"
            icon={StethoscopeIcon}
            title="Salve vidas"
          />
        </div>
        <img
          alt="Logo GPMED"
          className="relative mx-auto my-12 h-14 w-auto"
          src={LogoHorizontal}
        />

        <Link
          className="text-white underline hover:opacity-60"
          preload={false}
          replace
          to="/sign-in">
          Desconectar
        </Link>
      </main>
    </div>
  );
}

type InfoProps = {
  description: string;
  icon: LucideIcon;
  title: string;
};

function Info({ description, icon: Icon, title }: InfoProps) {
  return (
    <div className="flex items-center px-3 py-2">
      <Icon
        className="mr-4 size-12 text-white md:mr-8 md:size-18"
        strokeWidth="1"
      />
      <div>
        <h3 className="text-lg font-semibold text-white md:text-xl">{title}</h3>
        <p className="text-sm text-white lg:text-base">{description}</p>
      </div>
    </div>
  );
}
